import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import MetaTags from "react-meta-tags";
import { Card, CardBody, Col, Container, Row } from "reactstrap";
import BootstrapTable from "react-bootstrap-table-next";
import ToolkitProvider from "react-bootstrap-table2-toolkit";
import filterFactory, { textFilter } from "react-bootstrap-table2-filter";
import Breadcrumbs from "components/Common/Breadcrumb";
import { getAnalyteResultParticipant } from "store/results/actions";
import "assets/scss/table.scss";

class StatisticParticipant extends Component {
  constructor(props) {
    super(props);
    this.state = {
      participantData: [],
      analyteName: "",
      idFilter: "",
      nameFilter: "",
      sampleConditionFilter: "", // optional text filter
      zScoreFilter: "",
      selectedSampleCondition: "",
      // Will hold filtered participants
    };
  }
  componentDidMount() {
    const { scheme_id, roundId, analyteId } = this.props.match.params;
    // scheme_id=59, roundId=92, analyteId=13

    console.log("Params:", this.props.match.params); // verify order here

    if (scheme_id && roundId && analyteId) {
      this.props.onGetAnalyteResultParticipant(scheme_id, roundId, analyteId);
    }
  }

  componentDidUpdate(prevProps) {
    const prev = prevProps.getAnalyteResultParticipant;
    const curr = this.props.getAnalyteResultParticipant;

    if (
      curr.length !== prev.length ||
      JSON.stringify(curr) !== JSON.stringify(prev)
    ) {
      this.setParticipantsFromProps();
    }
  }
  setParticipantsFromProps = () => {
    const { getAnalyteResultParticipant } = this.props;
    const { scheme_id, roundId, analyteId } = this.props.match.params;

    // 🔍 DEBUG: Check what we're working with
    console.log("Params from URL:", { scheme_id, roundId, analyteId });
    console.log("API Data:", getAnalyteResultParticipant);
    console.log("Looking for round_id:", Number(roundId));
    console.log(
      "Available round_ids:",
      getAnalyteResultParticipant.map((i) => i.round_id),
    );

    const roundData = getAnalyteResultParticipant.find(
      (item) => item.round_id === Number(roundId),
    );

    console.log("Found roundData:", roundData); // 🔍 null = param mismatch

    if (!roundData) {
      this.setState({ participantData: [] });
      return;
    }

    console.log(
      "Available analyte_ids:",
      roundData.analytes.map((a) => a.analyte_id),
    );
    console.log("Looking for analyte_id:", Number(analyteId));

    const analyteData = roundData.analytes.find(
      (a) => a.analyte_id === Number(analyteId),
    );

    console.log("Found analyteData:", analyteData); // 🔍 null = analyte mismatch

    if (!analyteData) {
      this.setState({ participantData: [], analyteName: "" });
      return;
    }

    console.log("Participants raw:", analyteData.participants); // 🔍 check structure

    const participants = analyteData.participants.map((p) => {
      let condition = p.sample_condition;

      // 🚀 Handle all bad cases
      if (
        condition === null ||
        condition === undefined ||
        condition === "" ||
        condition === "null" ||
        condition === "undefined"
      ) {
        condition = "-";
      }

      return {
        id: p.id,
        participant_name: p.name,
        sample_condition: condition,
        z_score:
          p.z_score !== undefined && p.z_score !== null ? p.z_score : "-",
      };
    });

    console.log("Mapped participants:", participants); // 🔍 final check

    this.setState({
      participantData: participants,
      analyteName: analyteData.analyte_name || "",
    });
  };

  handleFilterChange = (field, event) => {
    this.setState({ [field]: event.target.value });
  };

  resetFilters = () => {
    this.setState({
      idFilter: "",
      nameFilter: "",
    });
  };
  getFilteredData = () => {
    const {
      idFilter,
      nameFilter,
      sampleConditionFilter,
      zScoreFilter,
      selectedSampleCondition,
      participantData,
    } = this.state;

    return participantData.filter((item) => {
      const matchId = item.id
        .toString()
        .toLowerCase()
        .includes(idFilter.toLowerCase());
      const matchName = item.participant_name
        .toLowerCase()
        .includes(nameFilter.toLowerCase());
      const matchConditionText = (item.sample_condition || "")
        .toLowerCase()
        .includes(sampleConditionFilter?.toLowerCase() || "");
      const matchZScore = (item.z_score?.toString() || "")
        .toLowerCase()
        .includes(zScoreFilter?.toLowerCase() || "");

      // Match dropdown filter if selected
      const matchDropdown =
        !selectedSampleCondition ||
        item.sample_condition === selectedSampleCondition;

      return (
        matchId &&
        matchName &&
        matchConditionText &&
        matchZScore &&
        matchDropdown
      );
    });
  };
  // Formatter for Participant ID - bold text
  participantIdFormatter = (cell) => <strong>{cell}</strong>;

  // Formatter for Participant Name - blue text
  participantNameFormatter = (cell) => (
    <span style={{ color: "blue" }}>{cell}</span>
  );
  getSampleConditionCounts = () => {
    const { participantData } = this.state;

    const counts = {
      Clotted: 0,
      Hemolyzed: 0,
      Clear: 0,
      Icteric: 0,
      Lipemic: 0,
      "Not Selected": 0,
    };

    participantData.forEach((p) => {
      const cond = p.sample_condition || "Not Selected";
      if (counts[cond] !== undefined) {
        counts[cond]++;
      } else {
        counts["Not Selected"]++;
      }
    });

    return counts;
  };
  goBack = () => {
    this.props.history.goBack(); // navigates to the previous page
  };
  render() {
    const columns = [
      // {
      //   dataField: "id",
      //   text: "ID",
      //   sort: true,
      //   formatter: (cell, row) => <strong>{cell}</strong>,
      //  headerFormatter: (column) => (
      //   <>
      //     <div>
      //       <input
      //         type="text"
      //         value={this.state.idFilter}
      //         onChange={(e) => this.handleFilterChange("idFilter", e)}
      //         className="form-control"
      //       />
      //     </div>
      //     <div style={{ textAlign: "center", marginTop: "4px" }}>
      //       {column.text}
      //     </div>
      //   </>
      // ),

      //   headerStyle: { width: '50px' },
      //   style: { width: '50px' },
      // },
      {
        dataField: "participant_name",
        text: "Participant Name",
        sort: true,
        formatter: (cell) => <span style={{ color: "black" }}>{cell}</span>,
        headerFormatter: (column) => (
          <>
            <div>
              <input
                type="text"
                value={this.state.nameFilter}
                onChange={(e) => this.handleFilterChange("nameFilter", e)}
                className="form-control"
              />
            </div>
            <div style={{ textAlign: "center" }}>{column.text}</div>
          </>
        ),
        headerAlign: "center", // header remains centered
        align: "left", // cell data aligned left
        headerStyle: { width: "50px" },
        style: { width: "50px" },
      },
      {
        dataField: "sample_condition",
        text: "Sample Condition",
        sort: true,
        formatter: (cell) => <span style={{ color: "black" }}>{cell}</span>,
        headerFormatter: (column) => (
          <>
            <div>
              <input
                type="text"
                value={this.state.sampleConditionFilter}
                onChange={(e) =>
                  this.handleFilterChange("sampleConditionFilter", e)
                }
                className="form-control"
              />
            </div>
            <div style={{ textAlign: "center" }}>{column.text}</div>
          </>
        ),
        headerAlign: "center", // Header stays centered
        align: "center", // Cell data aligned left
        headerStyle: { width: "50px" },
        style: { width: "50px" },
      },
      {
        dataField: "z_score",
        text: "Z-Score",
        sort: true,
        formatter: (cell) => <span style={{ color: "black" }}>{cell}</span>,
        headerFormatter: (column) => (
          <>
            <div>
              <input
                type="text"
                value={this.state.zScoreFilter || ""}
                onChange={(e) => this.handleFilterChange("zScoreFilter", e)}
                className="form-control"
              />
            </div>
            <div>{column.text}</div>
          </>
        ),
        headerAlign: "center",
        align: "center",
        headerStyle: { width: "50px" },
        style: { width: "50px" },
      },
    ];

    const defaultSorted = [{ dataField: "id", order: "asc" }];

    return (
      <React.Fragment>
        <div className="page-content">
          <MetaTags>
            <title>Statistic Participants</title>
          </MetaTags>
          <Container fluid>
            <Breadcrumbs title="List" breadcrumbItem="Participants List" />
            <Row className="justify-content-center">
              <Row className="justify-content-start mb-3">
                <Col lg="10">
                  <button
                    className="btn btn-primary btn-sm"
                    onClick={this.props.history.goBack} // using history from props
                  >
                    Back
                  </button>
                </Col>
              </Row>
              <Row className="justify-content-center mb-3">
                <Col lg="10">
                  <h5>
                    Analyte:{" "}
                    <span className="text-primary">
                      {this.state.analyteName}
                    </span>
                  </h5>
                </Col>
              </Row>
              <Col lg="10">
                <Card>
                  <CardBody>
                    <ToolkitProvider
                      keyField="id"
                      data={this.getFilteredData()}
                      columns={columns}
                      search
                    >
                      {(toolkitprops) => (
                        <div className="table-responsive">
                          <Row className="mb-3">
                            <Col lg="3">
                              <label>Filter by Sample Condition</label>
                              <select
                                className="form-control"
                                value={this.state.selectedSampleCondition}
                                onChange={(e) =>
                                  this.setState({
                                    selectedSampleCondition: e.target.value,
                                  })
                                }
                              >
                                <option value="">All</option>
                                <option value="Clear">Clear</option>
                                <option value="Clotted">Clotted</option>
                                <option value="Hemolyzed">Hemolyzed</option>
                                <option value="Icteric">Icteric</option>
                                <option value="Lipemic">Lipemic</option>
                                {/* <option value="Not Selected">Not Selected</option> */}
                              </select>
                            </Col>
                          </Row>
                          <Row className="mb-3">
                            <Col md={12}>
                              <div className="d-flex flex-wrap align-items-center gap-3">
                                <span
                                  className="text-muted fw-semibold"
                                  style={{
                                    fontSize: "13px",
                                    whiteSpace: "nowrap",
                                  }}
                                >
                                  Sample Condition:
                                </span>

                                {Object.entries(
                                  this.getSampleConditionCounts(
                                    this.getFilteredData(),
                                  ),
                                )
                                  .filter(
                                    ([condition, count]) =>
                                      condition &&
                                      condition !== "null" &&
                                      condition !== "undefined" &&
                                      condition.trim() !== "" &&
                                      count > 0,
                                  )
                                  .map(([condition, count]) => (
                                    <div
                                      key={condition}
                                      className="border rounded px-3 py-1 d-flex align-items-center gap-2"
                                    >
                                      <span
                                        className="text-muted"
                                        style={{ fontSize: "12px" }}
                                      >
                                        {condition}
                                      </span>
                                      <strong
                                        style={{
                                          fontSize: "15px",
                                          cursor: "pointer",
                                          color: "#0d6efd",
                                        }}
                                        // onClick={() => this.handleConditionClick(condition)}
                                        title="Click to filter labs"
                                      >
                                        {count}
                                      </strong>
                                    </div>
                                  ))}
                              </div>
                            </Col>
                          </Row>
                          <BootstrapTable
                            {...toolkitprops.baseProps}
                            bordered={false}
                            striped
                            hover
                            condensed
                            defaultSorted={defaultSorted}
                            filter={filterFactory()}
                          />
                        </div>
                      )}
                    </ToolkitProvider>
                  </CardBody>
                </Card>
              </Col>
            </Row>
          </Container>
        </div>
      </React.Fragment>
    );
  }
}

StatisticParticipant.propTypes = {
  match: PropTypes.object.isRequired,
  getAnalyteResultParticipant: PropTypes.array.isRequired,
  onGetAnalyteResultParticipant: PropTypes.func.isRequired,
  history: PropTypes.object.isRequired, //
};

const mapStateToProps = (state) => {
  const analyteResultParticipant =
    state.SchemeAnalytesList?.getAnalyteResultParticipant || [];
  return {
    getAnalyteResultParticipant: analyteResultParticipant,
  };
};
const mapDispatchToProps = (dispatch) => ({
  onGetAnalyteResultParticipant: (schemeId, roundId, analyteId) => {
    dispatch(getAnalyteResultParticipant(schemeId, roundId, analyteId));
  },
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(withRouter(StatisticParticipant));
